module.exports = "/1/9-toan-tu-tang-giam/index.html.17809ba92bb7526bb6d72300ea06de47.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29945.md
 ** module id = 538
 ** module chunks = 0
 **/